import { createSlice } from '@reduxjs/toolkit'

export type FormMissionQuestion = {
  id: string
  title: string
  isRequired: boolean
  order: number
} & (TextQuestion | MultipleChoiceQuestion | FileUploadQuestion)

type TextQuestion = {
  type: 'text'
}

type FileUploadQuestion = {
  type: 'file_upload'
}

type MultipleChoiceQuestion = {
  type: 'multiple_choice'
  isMultipleSelection: boolean
  choices: Array<Choice>
}

type Choice = {
  id: string
  text: string
  questionId: string
}

interface Answer {
  textValue: string | null
  choiceValues: string[] | null
  fileUrl: string | null
  questionId: string
  userId: number
  isCorrect?: boolean
}

interface FormSubmissionMap {
  [formId: string]: Answer[]
}

export interface FormQuestionsSlice {
  formId: string
  questions: FormMissionQuestion[]
  currentQuestionIndex: undefined | number
  formSubmission: FormSubmissionMap
}

const initialState: FormQuestionsSlice = {
  formId: '',
  questions: [],
  currentQuestionIndex: undefined,
  formSubmission: {},
}

export const formQuestions = createSlice({
  name: 'formQuestions',
  initialState,
  reducers: {
    setFormId: (state, action) => {
      state.formId = action.payload
      return state
    },
    setFormQuestions: (state, action) => {
      const questions: FormMissionQuestion[] = action.payload
      state.questions = [...questions].sort((a, b) => a.order - b.order)
      return state
    },
    setNextQuestion: (state) => {
      let currentQuestionIndex = state.currentQuestionIndex
      if (currentQuestionIndex === undefined) currentQuestionIndex = 0
      else currentQuestionIndex += 1
      state.currentQuestionIndex = currentQuestionIndex
      return state
    },
    setPreviousQuestion: (state) => {
      let currentQuestionIndex = state.currentQuestionIndex
      if (state.currentQuestionIndex === 0) currentQuestionIndex = undefined
      else currentQuestionIndex -= 1
      state.currentQuestionIndex = currentQuestionIndex
      return state
    },
    setFormSubmission: (state, action) => {
      state.formSubmission = action.payload
      return state
    },
  },
})

export const {
  setFormQuestions,
  setNextQuestion,
  setPreviousQuestion,
  setFormId,
  setFormSubmission,
} = formQuestions.actions

export default formQuestions.reducer
